import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { MyLibraryLogIn } from './module';

const initialState = {
    status: "idle",
    isCaptcha: true,
    dateFrom: null,
    dataUrl: null,
    isDateWithin3Years: true,
    selectDays: 0,
    isNumberCorrect: true,
    ActionStatus: "",
    errorMessage: ""
};

export const MyLibraryLogInAsync = createAsyncThunk(
    'schoolForm/MyLibraryLogIn',
    async (data, ThunkAPI) => {
        const response = await MyLibraryLogIn(data);
        return response;
    }
);

export const schoolFormSlice = createSlice({
    name: 'schoolForm',
    initialState,
    reducers: {
        captchaChecked: (state, action) => {
            state.isCaptcha = action.payload;
        },
        validateNumber: (state, action) => {
            state.isNumberCorrect = action.payload;
        },
        saveDateFrom: (state, action) => {
            state.dateFrom = action.payload;
        },
        validateDate: (state, action) => {
            state.isDateWithin3Years = action.payload.is3years;
            state.selectDays = action.payload.days;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(MyLibraryLogInAsync.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(MyLibraryLogInAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(MyLibraryLogInAsync.fulfilled, (state, action) => {
            state.status = 'idle';
            if (action.payload && action.payload.Status !== 'OK') {
                alert(action.payload.ErrorMessage);
            } else {
                state.dataUrl = action.payload.LoginUrl;
            }
        });
    }
});

export const { captchaChecked, validateNumber, saveDateFrom, validateDate } = schoolFormSlice.actions;
export const pagesState = (state) => state.schoolForm;
export const myLibs = (state) => state.Session.myLibs;
export const formData = (state) => state.schoolSummary.schoolFormData;

export default schoolFormSlice.reducer;
